import { useMemo } from "react";
import { useParams } from "react-router";
import { marked } from "marked";
import terms from "../../../../docs/legal/terms-of-service.md?raw";
import privacy from "../../../../docs/legal/privacy-policy.md?raw";
import disclaimer from "../../../../docs/legal/disclaimer.md?raw";

const docs: Record<string, { title: string; body: string }> = {
  terms: { title: "利用規約", body: terms },
  privacy: { title: "プライバシーポリシー", body: privacy },
  disclaimer: { title: "免責事項", body: disclaimer },
};

/** The markdown files start with an editorial note and a horizontal rule; show only what follows. */
const publicPart = (md: string): string => {
  const i = md.indexOf("\n---\n");
  return i >= 0 ? md.slice(i + 5) : md;
};

export function LegalPage() {
  const { doc = "" } = useParams();
  const entry = docs[doc];
  const html = useMemo(() => (entry ? (marked.parse(publicPart(entry.body), { async: false }) as string) : ""), [entry]);
  if (!entry) return <p className="muted">文書が見つかりません。</p>;
  return <section className="prose" dangerouslySetInnerHTML={{ __html: html }} />;
}
